<div
  class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
>
  @if (fileAsBase64 && isImageUpload()) {
    <figure
      class="image is-128x128 mb-6 is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
    >
      <img [src]="fileAsBase64" />
    </figure>
  }

  @if (fileAsBase64 && isPDFUpload()) {
    <div class="pdf-viewer mb-6">
      <ng2-pdfjs-viewer
        viewerId="JobPdfViewer"
        [showSpinner]="false"
        pagemode="thumbs"
        [pdfSrc]="fileAsBinary"
      ></ng2-pdfjs-viewer>
    </div>
  }

  @if (!fileAsBase64) {
    <div class="file is-flex is-fullwidth" [class.has-name]="fileName">
      <label class="file-label">
        <input
          class="file-input"
          (change)="onFileChange($event)"
          type="file"
          name="imageUpload"
          [accept]="accept()"
        />
        <span
          class="file-cta is-primary is-fullwidth is-fullheight is-flex-direction-column is-justify-content-centeris-flex p-6"
        >
          <span class="file-icon mt-6">
            <fino-icon [icon]="icon()" class="icon"></fino-icon>
          </span>
          <span
            class="file-label is-fullwidth is-justify-content-center mt-2 has-text-weight-bold mb-6"
            translate
          >
            components.image-upload.button
          </span>
        </span>
        @if (fileName) {
          <span class="file-name">{{ fileName }}</span>
        }
      </label>
    </div>
  }
</div>
